/** @format */
"use client";

import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { Button, Box, Tooltip } from "@radix-ui/themes";
import React from "react";

interface ActionProps {
  handleBack(): void;
}

const BackButton: React.FC<ActionProps> = (props) => {
  return (
    <Box>
      <Tooltip content="Back">
        <Button
          variant="outline"
          className="!rounded-full hover:cursor-pointer w-6 h-6 flex items-center justify-center p-[5px]"
          radius="full"
          size="1"
          color="gray"
          onClick={() => props.handleBack()}
          aria-label="Go back"
          role="button"
        >
          <ArrowLeftIcon
            width={"16"}
            height={"16"}
            className="text-secondary-default"
          />
        </Button>
      </Tooltip>
    </Box>
  );
};
export default BackButton;
